// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";

interface OwnProps {
    id: string;
}

export interface FooterCopyrightContainerStyles {
    container?: InjectableCss;
    innerContainer?: InjectableCss;
    copyright?: TypographyPresentationProps;
}

export const footerCopyrightContainerStyles: FooterCopyrightContainerStyles = {};

const styles = footerCopyrightContainerStyles;
const FooterCopyrightContainer: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.innerContainer}>
                <Typography {...styles.copyright}>
                    {siteMessage("Custom_Footer_Copyright", String(new Date().getFullYear()))}
                </Typography>
                <Zone zoneName="Extra Links Section" contentId={id} normalWidth={true} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default FooterCopyrightContainer;
